import React, { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { NavLink } from 'react-router-dom'
import Editor from '../Editor';
import { actualitiesLink, adminActualityCategoryLink, adminActualityListLink } from '../../constants/endspoints';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { BASE_URL_CATEGORIES, fetchCategories } from '../../api/categories';
import { createArticle } from '../../api/article';
import { toast } from 'react-toastify';
import Modal from 'react-responsive-modal';

const Actualities = () => {


    const {register,formState: { errors },handleSubmit} = useForm();

    const [title, setTitle] = useState('')
    const [category, setCategory] = useState('')
    const [content, setContent] = useState('')
    const [contentErr, setContentErr] = useState(false)
    const [clearEditor, setClearEditor] = useState(false)
    const [modalClipboard, setModalClipboard] = useState(false)
    const [articleLink, setArticleLink] = useState('')
    const [copied, setCopied] = useState(false);


    // Fetch all categories
    const queryClient = useQueryClient();
    const { data: categoriesData } = useQuery({
        queryKey: ['categories'],
        queryFn: fetchCategories,
    });




    // Create actuality
    const toastAct = useRef(null);
    const addActuality = useMutation({
        mutationFn: (data)=> createArticle(data),
        onMutate: ()=>{
            toastAct.current = toast.loading("Création en cours...", { 
                position: 'top-right',
            });
        },
        onSuccess: (res) => {
            queryClient.invalidateQueries(['actualities']);
            toast.dismiss(toastAct.current)
            toastAct.current = toast.success("Actualité créée avec succès", {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            setArticleLink(window.location.origin + actualitiesLink + '/' + res.data.id)
            setModalClipboard(true)
            setTitle('')
            setContent('')
            setCategory('')
            setClearEditor(true)
        },
        onError: (err) =>{
            toast.dismiss(toastAct.current)
            toastAct.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true
            });
        }
    });

    const submit = () =>{
        if (!content) {
            setContentErr(true)
            return
        }
        addActuality.mutate({title:title, content:content, Category:`${BASE_URL_CATEGORIES}/${category}`})
        setContentErr(false)
    }



    // Copy link to clipboard
    const handleCopy = () => {
        navigator.clipboard.writeText(articleLink).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
        });
    };



    return (
        <div>
            <h1 className='fs-3 fw-bold mb-2'>Actualités</h1>

            {/* Submenu */}
            <div className="d-flex justify-content-start align-items-center mb-3 menu">
                <NavLink to={adminActualityListLink} className='d-flex align-items-center px-2 py-1 me-2 mb-2 nav-link border bordercolor-primary rounded-3'>
                    <i className="fa-light fa-list-timeline me-2 text-white"></i>
                    <span className=' fs-9s text-white'>Toutes les actualités</span>
                </NavLink>
                <NavLink to={adminActualityCategoryLink} className='d-flex align-items-center px-2 py-1 me-2 mb-2 nav-link border bordercolor-primary rounded-3'>
                    <i className="fa-light fa-square-plus me-2 text-white"></i>
                    <span className=' fs-9s text-white'>Ajouter une catégorie</span>
                </NavLink>
            </div>

            {/* form */}
            <form onSubmit={handleSubmit(submit)} className='bg-black rounded-3 p-2 shadow'>
                <h2 className='fs-5 fw-bold mb-2'>Créer une actualites</h2>

                <div className=' row justify-content-start align-items-start'>
                    <div className=' col-md-6 col-12'>
                        <div>
                            <div className='col-12 mt-3'>
                                <div className='inputBox'>
                                    <input {...register("title", {required: true })} onChange={(e)=>(setTitle(e.target.value))} value={title} type='text' className='w-100 fs-9s' required/>
                                    <span>Titre</span>
                                    <i></i>
                                </div>
                                {errors.title && <small className="text-danger fs-7s" role="alert">Titre requis</small>}
                            </div>

                            <div className='col-12 mt-3'>
                                <div className='inputBox w-100'>
                                    <select  {...register("category", {required: true})}  onChange={(e)=>setCategory(e.target.value)} value={category} className='w-100 fs-9s bg-black'>
                                        <option value={""} className='text-capitalize fs-9s' defaultValue> --Selectionnez une catégorie--- </option>
                                        {categoriesData?.data?.length !== 0 ?
                                            categoriesData?.data?.map((cat, index) => (
                                                <option key={index} value={cat.id} className='fs-9s'>{cat.name}</option>
                                            ))
                                        :
                                        <option onChange={(e)=>{setCategory(e.target.value);}} value={null}>--Aucune valeur--</option>
                                        }
                                    </select>
                                    <span>Sélectionner une catégorie</span>
                                    <i></i>
                                </div>
                                {errors.category && <small className="text-danger fs-7s" role="alert">Catégorie requise</small>}
                            </div>

                            <div className='col-12 mt-3'>
                                <label className='fs-9s color-primary'>Editeur de contenu</label>
                                <Editor getData={setContent} clearForm={clearEditor}/>
                                {contentErr && <small className="text-danger fs-7s" role="alert">Contenu requis</small>}
                            </div>
                        </div>
                    </div>

                    {/* Preview */}
                    <div className=' col-md-6 col-12'>
                        <div className=' mt-md-0 mt-4' style={{maxHeight: "90vh", overflowY: "auto"}}>
                            <h5 className=' fs-6 fw-bold'>Prévisualisation</h5>
                            {/* Hero */}
                            <div className='bgcolor-hero-actuality mb-1'>
                                <div className='container-xxl h-100'>
                                    <div className=' d-flex flex-column justify-content-end align-items-center text-center h-100 w-100 mx-auto' style={{maxWidth:'768px'}}>
                                        <h2 className=' fs-3 text-uppercase fw-bold'>{title}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className='mx-auto' style={{maxWidth:'768px'}}>
                
                                <div className='d-flex flex-grow-0 justify-content-end'>
                                    <span className=' px-2 py-0 mb-1 bgcolor-secondary text-truncate-1 fs-8s w-auto'>{categoriesData?.data?.find(cat => cat.id ===  parseInt(category))?.name}</span>
                                </div>
                                <div className='tiptap' dangerouslySetInnerHTML={{__html: content}}></div>
                
                                <hr/>
                
                                <div className=' d-flex justify-content-end'>
                                    <span className='fst-italic fs-9s'>{new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
                                </div>
                
                            </div>
                        </div>
                    </div>
                </div>

                <button disabled={addActuality.isPending} type='submit' className='d-flex align-items-center px-2 py-1 me-2 mt-3 mb-2 bgcolor-primary rounded-2'>
                    <i className="fa-light fa-paper-plane-top me-2 text-white"></i>
                    <span className=' fs-9s text-white'>Créer</span>
                </button>
            </form>

            
            {/* Modal clipboard */}
            <Modal 
                open={modalClipboard}
                onClose={() =>{setModalClipboard(false); setArticleLink('')}} 
                center 
                closeIcon={<i className="fa-light fa-xmark text-white"></i>}
                focusTrapped={false}
                classNames={{ modal: 'bg-black text-white  rounded-3 p-2 border bordercolor-primary' }} 
                styles={{ overlay: { background: 'rgba(0, 0, 0, 0.7)' } }}>
                <div className='d-flex flex-column p-2 justify-content-center align-items-center'>
                    <h2 className='fs-5 fw-bold mt-2 mb-3'>Actualité créée</h2>
                    <h4 className='fs-9s mt-2 mb-3'>Elle doit être validée par l'administrateur pour être visible</h4>
                    {/* <a href={articleLink} target='_blank' rel='noreferrer' className='fs-9s text-white text-decoration-underline fst-italic'>{articleLink}</a>
                    <button 
                        onClick={handleCopy} 
                        className={'d-flex align-items-center px-2 py-1 mt-3 mb-2 rounded-2 border-1 bordercolor-primary ' + (copied ? 'bgcolor-primary' : 'bg-transparent')}>
                        <i className="fa-light fa-copy me-2 text-white"></i>
                        <span className='fs-9s text-white'>{copied ? 'Lien copié !' : 'Copier le lien'}</span>
                    </button> */}
                </div>

            </Modal>

        </div>
    )
}

export default Actualities